import { DateTime } from "luxon";

const toSlotPickerZone = (timeZoneId?: string) =>
  timeZoneId ?? DateTime.local().zoneName;

const toDateTimeInZone = (iso: string, timeZoneId?: string) =>
  DateTime.fromISO(iso, { zone: toSlotPickerZone(timeZoneId) });

const toStartOfDayInZone = (dateTime: DateTime, timeZoneId?: string) =>
  dateTime.setZone(toSlotPickerZone(timeZoneId)).startOf("day");

const nowStartOfDayInZone = (timeZoneId?: string) =>
  DateTime.now().setZone(toSlotPickerZone(timeZoneId)).startOf("day");

export {
  nowStartOfDayInZone,
  toDateTimeInZone,
  toSlotPickerZone,
  toStartOfDayInZone,
};
